import React, { Fragment } from "react";
import { FormattedDate } from "react-intl";
import moment from "moment";
const DateOfService = ({ account }) => {
    const { admitDate, dischargeDate } = account;
    let admitDateView;
    if (admitDate != null) {
        admitDateView = (<FormattedDate value={moment(admitDate).toDate()}/>);
    }
    let dischargeDateView;
    if (dischargeDate != null && dischargeDate !== admitDate) {
        dischargeDateView = (<FormattedDate value={moment(dischargeDate).toDate()}/>);
    }
    return (<Fragment>
			{admitDateView}
			{admitDateView != null && dischargeDateView != null && (" - ")}
			{dischargeDateView}
		</Fragment>);
};
export default DateOfService;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/DateOfService/DateOfService.tsx